<template>
  <el-col :span="24" align="middle" id="login" v-loading="loading" element-loading-text='Authenticating...'>
    <el-row type="flex" justify="start" align="middle" class="login-form-wrapper">
      <el-col :span="12" class="left-padded left-aligned-col">
        <el-row type="flex">
          <el-col :span="8"></el-col>
          <el-col :span="16">
            <el-row type="flex" justify="start" align="middle">
              <div class="grid-content login-row">
                <h3>Login</h3>
              </div>
            </el-row>
            <el-row type="flex" justify="start" align="middle" gutter="10" class="v-padded-s" v-if="instances && instances.length">
              <!-- <el-col :span="3" class="right-aligned-col">
                <el-input value="https://" disabled/>
              </el-col> -->
              <el-col :span="16" class="right-aligned-col">
                <el-select style="width: 100%;" v-model="instance" placeholder="Select an instance">
                  <el-option v-for="(v, i) in instances" :key="i" style="padding: 0;" :label="v.name" :value="v.url">
                    <el-row type="flex" align="middle" style="height: 36px; padding: 0 10px;">
                      <el-col style="height: 36px;" :span="21">
                        <div @click="handleInstanceSelect(v.url)" style="display: table; height: 36px; width: 100%;">
                          <span style="display: table-cell; vertical-align: middle; width: 100%;">
                            {{ v.name || v.url }}
                          </span>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <el-row type="flex" align="middle" justify="end">
                          <el-button size="mini" icon="close" style="z-index: 1000;" @click="removeInstance(v.url)" />
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-option>
                  <el-option key="custom" label="Custom URL" style="padding: 0;" value="custom">
                    <el-row type="flex" align="middle" style="height: 36px;">
                      <div @click="addingCustomInstance = true" style="display: table; height: 36px; width: 100%; padding: 0 10px;">
                        <span style="display: table-cell; vertical-align: middle; width: 100%;">
                          Custom
                        </span>
                      </div>
                    </el-row>
                  </el-option>
                </el-select>
              </el-col>
              <!-- <el-col :span="5" class="left-aligned-col">
                <el-input value="sigmacloud.io" disabled/>
              </el-col> -->
            </el-row>
            <el-row
              v-if="!(instances && instances.length) || addingCustomInstance"
              type="flex"
              justify="start"
              align="middle"
              class="v-padded-s"
              style="padding: 10px 0;"
            >
              <el-col :span="24">
                <el-row type="flex" justify="start" align="middle" gutter="10">
                  <el-col :span="24" style="padding-bottom: 6px; font-size: 12px;">
                    Please enter an instance
                  </el-col>
                </el-row>
                <el-row type="flex" justify="start" align="middle" gutter="10">
                  <!-- <el-col :span="3">
                    <el-input value="https://" disabled />
                  </el-col> -->
                  <el-col :span="14">
                    <el-input v-model="instanceField" placeholder="Instance" />
                  </el-col>
                  <!-- <el-col :span="4">
                    <el-input :value="instanceServer" disabled />
                  </el-col> -->
                  <el-col :span="2">
                    <el-button
                      type="primary"
                      @click="addInstance"
                      icon="plus"
                      />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="e.g. johndoe" v-model="creds.username" :disabled="!instance" ref="usernameField">
                    <template slot="prepend">Username</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="********" type="password" v-model="creds.password" :disabled="!instance">
                    <template slot="prepend">Password</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="8">
                <router-link to="/forgot_password">Forgot Password?</router-link>
              </el-col>
              <el-col :span="8" class="right-aligned-col">
                <el-button
                  type="primary"
                  size='small'
                  :disabled="!hasCredentials || addingCustomInstance"
                  @click="login()"
                  icon="caret-right">
                  Login
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" style="text-align: center;">
        <SplashText></SplashText>
      </el-col>
    </el-row>
    <!-- <el-row class="terms-bottom" type="flex" justify="center" align="bottom">
      <el-col :span="4" class="right-aligned-col">
        <a class="m-left-20 blue" href="https://www.revolutiones.com/#/termsofuse" target="_blank">Terms of Use</a>
      </el-col>
      <el-col :span="4" class="right-aligned-col">
        <a class="m-left-20 blue" href="https://www.revolutiones.com/#/privacypolicy" target="_blank">Privacy Policy</a>
      </el-col>
    </el-row> -->
  </el-col>
</template>

<script>
  import SplashText from '../../SplashText.vue'
  import { mapGetters } from 'vuex'
  import isUrl from 'is-url'
  import store from '@/store/store'
  import { checkForInstances } from '@/utils/helpers/SigmacloudRetiring'

  export default {
    name: 'login',
    components: { SplashText },
    data () {
      return {
        instanceField: '',
        instance: '',
        creds: { username: '', password: '' },
        addingCustomInstance: false,
        loading: false
      }
    },
    methods: {
      isUrl,
      /*
      * Adds an instance manually, sets it as active, and calls login()
      * @return void
      */
      async addInstance () {
        try {
          let field
          let exp = new RegExp(`^(https:\\/\\/)?([a-zA-Z0-9_-]+)(${this.instanceServer})?\\/?$`, 'i')
          if (this.instanceField.includes('127.0.0') || this.instanceField.includes('localhost') || this.instanceField.includes('https') || this.instanceField.includes('http')) field = this.instanceField
          else if ((this.instanceField.includes('org') || this.instanceField.includes('com') || this.instanceField.includes('io')) && !this.instanceField.includes('https')) {
            field = 'https://' + this.instanceField
          } else {
            field = 'https://' + this.instanceField.replace(exp, '$2') + this.instanceServer
          }
          if (field[field.length - 1] !== '/') {
            field = field + '/'
          }
          const url = await this.$store.dispatch('addInstance', field, this.instanceField.replace(exp, '$2'))
          this.handleInstanceSelect(url)
          this.instanceField = ''
          this.addingCustomInstance = false
          setTimeout(() => this.focusOnUsernameField())
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Finds the username field and focuses on it
       */
      focusOnUsernameField () {
        if (this.$refs && this.$refs.usernameField && this.$refs.usernameField.$el) {
          const inputEl = [...this.$refs.usernameField.$el.children].find(child => child.tagName === 'INPUT')
          if (inputEl) {
            inputEl.focus()
          }
        }
      },
      /*
      * Removes an instance
      * @param {url} URL of instance to remove
      * @return void
      */
      async removeInstance (url) {
        await this.$store.dispatch('removeInstance', url)
        setTimeout(() => {
          if (this.activeInstance && this.activeInstance.url) {
            this.handleInstanceSelect(this.activeInstance.url)
          } else {
            this.handleInstanceSelect()
          }
        })
      },
      /*
      * Sets a selected instance
      * @param {i} selected instance url
      * @return void
      */
      handleInstanceSelect (url = null) {
        if (url) {
          const instance = this.instances.find(v => v.url === url)
          this.instance = instance && instance.url ? instance.url : ''
        } else {
          this.instance = ''
        }
      },
      /*
      * Logs the user in. First, sets the selected instance as the currently active instance.
      * @return void
      */
      async login () {
        try {
          this.loading = true
          const instance = this.instances.find(instance => instance.url === this.instance)
          await this.$store.dispatch('clearState')
          await this.$store.dispatch('switchActiveAppInstance', instance)
          const { username, password } = this.creds
          const payload = { username, password, url: this.activeInstance.url }
          await this.$store.dispatch('authenticate', payload)
          if (this.$store.getters.getToken) {
            let postAuthorizationRoute
            if (this.logoutNotifMsg) {
              this.$store.dispatch('setLogoutNotifMsg', '')
            }
            if (this.postAuthorizationRoute) {
              postAuthorizationRoute = this.postAuthorizationRoute
              this.$store.dispatch('setPostAuthorizationRoute', null)
            }
            return this.$router.push(postAuthorizationRoute ? { name: postAuthorizationRoute } : '/home')
          }
          this.loading = false
        } catch (e) {
          console.log(e)
          this.creds.username = ''
          this.creds.password = ''
          this.addingCustomInstance = false
          this.loading = false
          this.$store.dispatch('resetAuthFailure')
        }
      },
      /*
      * Calls login() when user presses the enter key
      * @return void
      */
      handleKeydown (e) {
        if (e && e.keyCode === 13) {
          this.validInstanceUrl ? this.addInstance() : this.login()
        }
      },
      /*
      * If this.logoutNotifMsg is set, displays that message as a notification
      * @return void
      */
      displayLogoutMsg () {
        if (this.logoutNotifMsg) this.$message({ message: this.logoutNotifMsg, type: 'warning', duration: 8000 })
      },
      /*
      * Displays authentication error
      * @return void
      */
      displayAuthError () {
        this.$message({ message: this.authFailure, type: 'error', duration: 10000 })
      },
      /*
      * Called in create hook. Checks if instances exist, and if so, finds the active one.
      * If none are active, sets the instance at index 0 as active
      * @return void
      */
      async findOrSetActiveInstance () {
        if (this.instances.length) {
          if (this.activeInstance && this.activeInstance.url) {
            this.instance = this.activeInstance.url
          } else {
            await this.$store.dispatch('clearState')
            this.$store.dispatch('switchActiveAppInstance', this.instances[0])
            this.instance = this.instances[0].url
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        authFailure: 'getAuthFailure',
        activeInstance: 'getActiveInstance',
        instances: 'getInstances',
        instanceServer: 'getInstanceServer',
        postAuthorizationRoute: 'getPostAuthorizationRoute',
        logoutNotifMsg: 'getLogoutNotifMsg'
      }),
      /*
      * Checks if user credentials are set
      * @return boolean
      */
      hasCredentials () {
        return !!(this.creds.username && this.creds.password)
      },
      /**
       * Determines whether the instance URL provided is valid
       */
      validInstanceUrl () {
        return this.instanceField.includes('localhost') || isUrl(this.instanceField)
      }
    },
    watch: {
      authFailure () {
        if (this.authFailure) {
          this.displayAuthError()
        }
      }
    },
    created () {
      this.displayLogoutMsg()
      this.findOrSetActiveInstance()

      // If being redirected with existing sessions, try to import into our localStorage "instances"
      if (checkForInstances(this.$route.query, store)) {
        this.$router.push({ query: null })
        this.$notify({ title: 'ProBooks has been updated', message: 'Please update your bookmarks to "https://probooks.revolutiones.com".', type: 'warning' })
      }
    },
    async beforeRouteEnter (to, from, next) {
      // Redirect if trying to access app.sigmacloud.io
      // checkForOldFrontend()

      await store.dispatch('verifyAuth')
      if (from.path === '/') {
        return next()
      }
      try {
        if (to.query.hasOwnProperty('instances') && Object.keys(to.query.instances).length) {
          await store.dispatch('fetchInstances', to.query.instances)
        } else {
          await store.dispatch('fetchInstances')
        }
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  #login {
    padding: 60px 0;
    background-color: #ffffff;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .login-form-wrapper h3 {
    padding: 12px 0;
  }
  .left-padded {
    padding-left: 12px;
  }
  .v-padded-s {
    padding: 6px 0;
  }
  .login-row {
    color: #324157;
  }
  #password {
    padding: 12px 0;
  }
  #login-register-btn-wrapper {
    padding: 12px 0;
  }
  .terms-bottom {
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Auth/Login.vue